import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';

const Discontinued = () => {
  return (
    <div className="sui-max-w-md" data-testid="fulfillment__unavailable" data-component="FulfillmentDiscontinued">
      <div>
        <Typography variant="h3" height="tight">This Item is Discontinued</Typography>
        <Typography variant="body-base" height="normal">
          <div className="sui-pt-2">We no longer carry this particular product.</div>
        </Typography>
      </div>
    </div>
  );
};

export { Discontinued };
